module.exports = __webpack_public_path__ + "static/fabrica-slide4-ad3ff8eb79a0348b92dfb69ebcea3eca.jpg";